import { render, staticRenderFns } from "./ContactsForMedia.vue?vue&type=template&id=d0271850&scoped=true&"
import script from "./ContactsForMedia.vue?vue&type=script&lang=js&"
export * from "./ContactsForMedia.vue?vue&type=script&lang=js&"
import style0 from "./ContactsForMedia.vue?vue&type=style&index=0&id=d0271850&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0271850",
  null
  
)

export default component.exports